export function getAPIURL() {
    return import.meta.env.VITE_VUE_APP_API_URL
}

export function getAPIURLEvents() {
    return import.meta.env.VITE_VUE_APP_API_URL_EVENTS
}